import type { EnterpriseOrPremiumLicenseStatus } from '../store/schema/enterpriseOrPremiumLicenseStore';
import { getStore } from '../store/store';
import { computeEnterpriseOrPremiumLicenseStatus } from '../utils/computeEnterpriseOrPremiumLicenseStatus';

export function getEnterpriseOrPremiumLicenseStatus(): EnterpriseOrPremiumLicenseStatus {
    if (!getStore().hasInitialized) {
        computeEnterpriseOrPremiumLicenseStatus();
    }

    return getStore().enterpriseOrPremiumLicenseStatus;
}
